var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDuty2Green(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.072,
    height: 36.838,
    viewBox: "0 0 34.072 36.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "orvosi_\\xFCgyelet_-_z\\xF6ld",
    transform: "translate(13159 13711.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Orvosi_\\xFCgyelet",
    transform: "translate(-13158 -13690.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10804",
    d: "M1631.907,416.129a20.77,20.77,0,0,1,9.739,5.417v0a10.418,10.418,0,0,1-.1,7.719,79.007,79.007,0,0,1-14.879,1.405c-.169,0-.338,0-.513,0h-.219a79.953,79.953,0,0,1-14.847-1.346,10.419,10.419,0,0,1,.009-8.121,20.812,20.812,0,0,1,9.317-5.064",
    transform: "translate(-1610.266 -416.129)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_337",
    cx: 1.553,
    cy: 1.553,
    r: 1.553,
    transform: "translate(22.862 4.578)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_746",
    y2: 3.782,
    transform: "translate(7.315 0.796)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_747",
    y2: 3.782,
    transform: "translate(24.415 0.796)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10805",
    d: "M1614.092,426.3v-2.88a3.056,3.056,0,1,1,6.112,0v2.88",
    transform: "translate(-1609.832 -415.649)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10843",
    d: "M1632.78,407.969a12.274,12.274,0,0,1-1.917,6.774h0a7.407,7.407,0,0,1-3.468,2.922h0a5.473,5.473,0,0,1-3.926,0h0a7.451,7.451,0,0,1-3.482-2.926,12.276,12.276,0,0,1-1.917-6.774c0-5.554,3.3-10.062,7.36-10.062S1632.78,402.415,1632.78,407.969Z",
    transform: "translate(-14767.383 -14108.238)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuty2Green);
export default __webpack_public_path__ + "static/media/duty2Green.fdf2b8b85ade1c4ab87e7193a2b992f8.svg";
export { ForwardRef as ReactComponent };